import { Header } from "../../components/Header"
import { useParams } from "react-router-dom";
import { WeaknessInstance } from "../../components/Weakness";
import { WeaknessInstanceData, getWeaknessInstance } from "../../remote/scan_data";
import { useEffect, useState } from "react";
import { ScanChildren } from "../../components/ScanChildren";
import { Box, CircularProgress, Container } from "@mui/material";

export const TreeWeakness = () => {
	const params = useParams()
	const entityId = params.entityId;

	if ( ! entityId) {
		return <CircularProgress />
	}

	const [weaknessData, setWeaknessData] = useState<WeaknessInstanceData | null>(null);
	useEffect(() => {
		getWeaknessInstance(entityId, (data, resp) => {
			if (data) {
				setWeaknessData(data);
			} else {
				setWeaknessData(null);
			}
		});
	}, [setWeaknessData]);

	return (weaknessData ? <>
		<Header />
		<Container>
			<WeaknessInstance id={entityId} data={weaknessData} hideChildren/>
			<Box margin={1}></Box>
			<ScanChildren data={weaknessData.children} />
		</Container>
	</> : <CircularProgress />)
}
